/**
 * Checks if the provided URL is a demo environment URL.
 * Matches:
 * - demo.thefoodchecker.com
 * - demo-{anything}.thefoodchecker.com (where {anything} is alphanumeric and dashes)
 * - pifoodportaldemo.azurewebsites.net
 * @param url The URL to check
 * @returns true if the URL is a demo environment, false otherwise
 */
export function isDemoUrl(url: string): boolean {
  return /demo(-[a-zA-Z0-9-]+)?\.thefoodchecker\.com/.test(url) || url.includes("pifoodportaldemo.azurewebsites.net");
}
